import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/usuario';

// LOGIN

function craerUsuario(state, action) {
  state.dataUsuarioParaInmueble= action.payload.usuario;
}

function conexionUsuario(state, action) {
  state.conexion= action.payload.conexion;
}

function errorUsuario(state, action) {
  state.error= action.payload.error;
}

function registrarUsuario(state, action) {
  state.dataUsuarioRegistrado= action.payload.dataUsuarioRegistrado;
  state.dataUsuarioRegistradomensaje= action.payload.dataUsuarioRegistradomensaje;
  
}




/**
 * Conexión
 */
const usuarioReducer = createSlice({
  name: 'usuario',
  initialState: initState,
  reducers: {
    craerUsuario,
    conexionUsuario,
    errorUsuario,
    registrarUsuario
  },
});

export const usuarioActions = {
  ...usuarioReducer.actions,
};

export default usuarioReducer.reducer;
